export const matchesRoute = (prefix) => {
  return window.location.pathname.startsWith(`${prefix}`);
};
